export enum PageType {
	Tour = 'tour',
	Hotel = 'hotel',
}
